// styles
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GirdedInfoIcon } from 'refactored/ui/icons';
import styled from 'styled-components';
import SoFormCandidateBlockDetailsInputs from './SoFormCandidateBlockDetailsInputs';
import SoFormCandidateBlockDetailsPriceBreakdown from './SoFormCandidateBlockDetailsPriceBreakdown';
import SoFormCandidateBlockDetailsTogglePriceBreakdown from './SoFormCandidateBlockDetailsTogglePriceBreakdown';
import { getExtras } from 'utils/order';

const ExtraPricesWarning = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 16px 16px;
  gap: 30px;

  height: 36px;

  /* secondary / white */

  background: #ffffff;
`;

const ExtraPricesWarningAlterMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  /* width: 568px; */
`;

const Frame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  /* width: 568px; */
  height: 20px;

  svg {
    path {
      fill: var(--accent700);
    }
  }
`;

const ExtraPricesWarningText = styled.div`
  height: 20px;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* grey / 700 */

  color: #54708c;
`;

const SoFormCandidateBlockDetails = ({ candidate }) => {
  const { t } = useTranslation('Quote');
  const { t: catalogT } = useTranslation('Catalog');

  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);
  const pricingStrategy = candidate.pricing_strategy;
  const quote = candidate.formData.quote;
  let hasExtras = false;
  if (pricingStrategy === 'INSTANT') {
    const extras = getExtras({
      priceInfo: quote,
      filterExtras: true,
      t,
      removeZeros: true,
    });
    const positiveExtras = extras.filter((e) => e.value > 0);
    hasExtras = positiveExtras.length > 0;
  }

  return (
    <>
      <SoFormCandidateBlockDetailsInputs candidate={candidate} />
      {pricingStrategy === 'INSTANT' && (
        <>
          {hasExtras && (
            <ExtraPricesWarning>
              <ExtraPricesWarningAlterMessage>
                <Frame>
                  <GirdedInfoIcon />
                  <ExtraPricesWarningText>
                    {catalogT('price.extra_included_warning')}
                  </ExtraPricesWarningText>
                </Frame>
              </ExtraPricesWarningAlterMessage>
            </ExtraPricesWarning>
          )}
          <SoFormCandidateBlockDetailsTogglePriceBreakdown
            showPriceBreakdown={showPriceBreakdown}
            onClick={() => {
              return setShowPriceBreakdown(!showPriceBreakdown);
            }}
          />
          {showPriceBreakdown && (
            <SoFormCandidateBlockDetailsPriceBreakdown
              quote={candidate.formData.quote}
            />
          )}
        </>
      )}
    </>
  );
};

export default styled(SoFormCandidateBlockDetails)``;
